var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import indoorHelper from "../../store/helpers/indoorHelper";
import { iconStyle, iconStyle3D } from "./constants";
export var getRequestBody = function (formData) {
    var _a, _b, _c, _d, _e;
    return {
        //indoor map id formated as user is expected to enter only the 1-5 digit micello id
        id: ((_a = formData === null || formData === void 0 ? void 0 : formData.indoorMapId) === null || _a === void 0 ? void 0 : _a.includes("indoormap") // added this as  formatting won't be required for update order since we already have formatted id
        )
            ? formData === null || formData === void 0 ? void 0 : formData.indoorMapId
            : (formData === null || formData === void 0 ? void 0 : formData.indoorMapId)
                ? "indoormap-00000000-0000-4000-a000-0000000" +
                    ((_b = formData === null || formData === void 0 ? void 0 : formData.indoorMapId) === null || _b === void 0 ? void 0 : _b.padStart(5, "0"))
                : null,
        name: formData === null || formData === void 0 ? void 0 : formData.indoorMapName,
        description: formData === null || formData === void 0 ? void 0 : formData.description,
        isPrivate: true,
        address: {
            label: (formData === null || formData === void 0 ? void 0 : formData.addressline1) +
                ((formData === null || formData === void 0 ? void 0 : formData.addressline2) ? " " + (formData === null || formData === void 0 ? void 0 : formData.addressline2) : ""),
            street: "",
            houseNumber: "",
            state: "",
            county: "",
            city: formData.city,
            district: "",
            subdistrict: "",
            country: (_c = formData === null || formData === void 0 ? void 0 : formData.country) === null || _c === void 0 ? void 0 : _c.label,
            countryCode: formData === null || formData === void 0 ? void 0 : formData.countryCode,
            postalCode: (_d = formData === null || formData === void 0 ? void 0 : formData.postCode) === null || _d === void 0 ? void 0 : _d.toString(),
        },
        location: {
            lat: (formData === null || formData === void 0 ? void 0 : formData.latitude) && parseFloat(formData === null || formData === void 0 ? void 0 : formData.latitude),
            lng: (formData === null || formData === void 0 ? void 0 : formData.longitude) && parseFloat(formData === null || formData === void 0 ? void 0 : formData.longitude),
        },
        venueCategory: indoorHelper.camelize((_e = formData === null || formData === void 0 ? void 0 : formData.indoorMapType) === null || _e === void 0 ? void 0 : _e.label),
        mapDetails: __assign(__assign(__assign({ sitePartial: (formData === null || formData === void 0 ? void 0 : formData.sitePartial) === "part", routingGraphs: formData === null || formData === void 0 ? void 0 : formData.routingGraphs }, ((formData === null || formData === void 0 ? void 0 : formData.siteFloors) && {
            siteFloors: parseInt(formData.siteFloors),
        })), ((formData === null || formData === void 0 ? void 0 : formData.siteSize) && {
            siteSize: parseInt(formData.siteSize),
        })), { buildingUnits: 1 }),
        modified: formData.modified,
    };
};
export var createFormHistory = function (newOrderForm) {
    return {
        indoorMapName: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.indoorMapName,
        indoorMapOrganizationId: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.indoorMapOrganizationId,
        indoorMapType: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.indoorMapType,
        addressline1: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.addressline1,
        addressline2: " " + (newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.addressline2),
        city: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.city,
        postCode: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.postCode,
        country: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.country,
        countryCode: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.countryCode,
        latitude: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.latitude,
        longitude: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.longitude,
        description: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.description,
        sitePartial: (newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.sitePartial) ? newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.sitePartial : "full",
        routingGraphs: !!(newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.routingGraphs) || false,
        siteFloors: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.siteFloors,
        siteSize: newOrderForm === null || newOrderForm === void 0 ? void 0 : newOrderForm.siteSize,
    };
};
export var updateOrderExistingData = function (venueObj) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        indoorMapName: venueObj === null || venueObj === void 0 ? void 0 : venueObj.name,
        indoorMapOrganizationId: venueObj === null || venueObj === void 0 ? void 0 : venueObj.indoorMapOrganizationId,
        indoorMapType: {
            value: (_a = venueObj === null || venueObj === void 0 ? void 0 : venueObj.venueCategory) === null || _a === void 0 ? void 0 : _a.split(/(?=[A-Z])/).join("_").toUpperCase(),
            label: ((_b = venueObj === null || venueObj === void 0 ? void 0 : venueObj.venueCategory) === null || _b === void 0 ? void 0 : _b.charAt(0).toUpperCase()) +
                ((_c = venueObj === null || venueObj === void 0 ? void 0 : venueObj.venueCategory) === null || _c === void 0 ? void 0 : _c.slice(1).split(/(?=[A-Z])/).join(" ")),
        },
        addressline1: (_d = venueObj === null || venueObj === void 0 ? void 0 : venueObj.address) === null || _d === void 0 ? void 0 : _d.label,
        addressline2: " ",
        city: (_e = venueObj === null || venueObj === void 0 ? void 0 : venueObj.address) === null || _e === void 0 ? void 0 : _e.city,
        postCode: (_f = venueObj === null || venueObj === void 0 ? void 0 : venueObj.address) === null || _f === void 0 ? void 0 : _f.postalCode,
        countryCode: (_g = venueObj === null || venueObj === void 0 ? void 0 : venueObj.address) === null || _g === void 0 ? void 0 : _g.countryCode,
        country: (_h = venueObj === null || venueObj === void 0 ? void 0 : venueObj.address) === null || _h === void 0 ? void 0 : _h.country,
        latitude: (_j = venueObj === null || venueObj === void 0 ? void 0 : venueObj.location) === null || _j === void 0 ? void 0 : _j.lat,
        longitude: (_k = venueObj === null || venueObj === void 0 ? void 0 : venueObj.location) === null || _k === void 0 ? void 0 : _k.lng,
        description: venueObj === null || venueObj === void 0 ? void 0 : venueObj.description,
        sitePartial: ((_l = venueObj === null || venueObj === void 0 ? void 0 : venueObj.mapDetails) === null || _l === void 0 ? void 0 : _l.sitePartial) === true ? "part" : "full",
        routingGraphs: !!((_m = venueObj === null || venueObj === void 0 ? void 0 : venueObj.mapDetails) === null || _m === void 0 ? void 0 : _m.routingGraphs) || false,
        siteFloors: (_o = venueObj === null || venueObj === void 0 ? void 0 : venueObj.mapDetails) === null || _o === void 0 ? void 0 : _o.siteFloors,
        siteSize: (_p = venueObj === null || venueObj === void 0 ? void 0 : venueObj.mapDetails) === null || _p === void 0 ? void 0 : _p.siteSize,
    };
};
export var newOrderDraftsObj = function (mapOrderObj, isUpdateOrder) {
    var _a, _b;
    return {
        orderData: {
            requesterInformation: mapOrderObj.requesterInformation,
            mapName: mapOrderObj.indoorMapName,
            notes: mapOrderObj.description,
            isPrivate: true,
        },
        draftType: isUpdateOrder ? "updateOrder" : "newOrder",
        address: {
            label: mapOrderObj.addressline1 + mapOrderObj.addressline2,
            street: "",
            houseNumber: "",
            state: "",
            county: "",
            city: mapOrderObj.city,
            district: "",
            subdistrict: "",
            country: (_a = mapOrderObj.country) === null || _a === void 0 ? void 0 : _a.label,
            countryCode: mapOrderObj.countryCode,
            postalCode: mapOrderObj.postCode,
        },
        location: { lat: mapOrderObj.latitude, lng: mapOrderObj.longitude },
        venueCategory: indoorHelper.camelize((_b = mapOrderObj.indoorMapType) === null || _b === void 0 ? void 0 : _b.label),
        draftHrn: null,
        mapDetails: __assign(__assign(__assign({ sitePartial: mapOrderObj.sitePartial === "part", routingGraphs: mapOrderObj.routingGraphs }, ((mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.siteFloors) && {
            siteFloors: parseInt(mapOrderObj.siteFloors),
        })), ((mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.siteSize) && {
            siteSize: parseInt(mapOrderObj.siteSize),
        })), { buildingUnits: 1 }),
    };
};
export var migrateOrderDraftsObj = function (mapOrderObj) {
    var _a, _b;
    return {
        orderData: {
            mapName: mapOrderObj.indoorMapName,
            notes: mapOrderObj.description,
            isPrivate: true,
        },
        draftType: "migrationOrder",
        address: {
            label: mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.addressline1,
            street: "",
            houseNumber: "",
            state: "",
            county: "",
            city: mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.city,
            district: "",
            subdistrict: "",
            country: (_a = mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.country) === null || _a === void 0 ? void 0 : _a.label,
            countryCode: "",
            postalCode: mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.postCode,
        },
        location: {
            lat: (mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.latitude) && parseFloat(mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.latitude),
            lng: (mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.longitude) && parseFloat(mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.longitude),
        },
        venueCategory: indoorHelper.camelize((_b = mapOrderObj === null || mapOrderObj === void 0 ? void 0 : mapOrderObj.indoorMapType) === null || _b === void 0 ? void 0 : _b.label),
    };
};
export var getIconProps = function (is3DViewerEnabled) {
    return {
        name: is3DViewerEnabled ? "3D" : "map-view",
        category: "map-view",
        size: "24px",
        style: is3DViewerEnabled ? iconStyle3D : iconStyle,
    };
};
